import util from "@bmp-vue/core/api/util";

const controller = "Gen0001";
export default Object.assign({}, util.GetCrud(controller, [""]), {
    Incluir: function(dto) {
        return util.Axios.Post(
            controller + "/eco",
            dto
        );
    },
    IncluirArquivo: function (dto, identEmissorPrincipal, identEmissorAdm) {
        const url = `${process.env.VUE_APP_ROOT_API}${controller}/eco/Importar`;
        const config = {
            headers: {
                'identEmissorPrincipal': identEmissorPrincipal,
                'identEmissorAdm': identEmissorAdm
            }
        };

        return  util.Axios.Dynamic('post', url, dto, config);
    },
    GetRespostaSincronaByCodigo: function(codigo) {
        return util.Axios.GetAll(controller + `/${codigo}/RespostaSincrona`)
    },
});